var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLsl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2755_4616",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2755_4616)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.3335H23V23.0002H0V15.3335Z",
    fill: "#55BB07"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.6665H23V15.3332H0V7.6665Z",
    fill: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H23V7.66667H0V0Z",
    fill: "#3D57DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9609 7.897C10.5853 8.03149 10.3869 8.37766 10.3869 8.99014C10.3869 9.6901 10.6446 10.3471 10.9609 10.6859V7.897ZM11.8594 10.6672C12.1669 10.3237 12.4141 9.67892 12.4141 8.99194C12.4141 8.39705 12.2188 8.05245 11.8594 7.90944V10.6672ZM11.8556 7.41827C12.4301 7.60054 12.843 8.13159 12.843 8.98634C12.843 9.61752 12.6178 10.3848 12.2687 10.9114L14.0179 13.199L14.4494 13.0095L15.0938 14.3125C15.0938 14.3125 13.4651 15.3334 11.4521 15.3334C9.43918 15.3334 7.90625 14.3125 7.90625 14.3125L8.45477 13.199L8.89775 13.3926L10.5207 10.9511C10.1563 10.4239 9.91947 9.63357 9.91947 8.98634C9.91947 8.10188 10.3616 7.56401 10.9674 7.40053C11.0037 7.18888 11.1881 7.02783 11.4102 7.02783C11.6383 7.02783 11.8268 7.19795 11.8556 7.41827Z",
    fill: "#1C1C1C"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2755_4616)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2755_4616",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLsl);
export default __webpack_public_path__ + "static/media/LSL.5bb638a885314d301051cb00e1b3ca36.svg";
export { ForwardRef as ReactComponent };